import React, { useEffect } from 'react';
import { ROUTES } from '@cyberint/common-utils';
import { useRouteTitle } from '../../hooks/useRouteTitle';

export const AsmTitle = ({ match, translate }) => {
  const { title, setTitle } = useRouteTitle(match);
  const params = match?.params?.['*']?.split('/');

  useEffect(() => {
    if (!title && params?.length === 2) {
      const subTitle =
        params[0] === ROUTES.DIGITAL_FOOTPRINT_ASSETS
          ? translate(`table.${params[1]}`)
          : translate(`issue_type.${params[1]}`);
      setTitle(`ASM: ${translate(`tabs.${params[0]}`)} / ${subTitle}`);
    }
  }, [params]);

  return <span>{title || '...'}</span>;
};
